import { isAndroid, isIOS } from "@memorang/helpers/platform";
import { GestureHandlerRootView } from "react-native-gesture-handler";

if (isIOS || isAndroid) {
	require("react-native-gesture-handler");
}

type Props = {
	children: React.ReactNode;
};

export const GestureHandlerRootHOC = ({ children }: Props) => {
	if (isIOS || isAndroid) {
		return (
			<GestureHandlerRootView
				style={{
					flex: 1,
				}}
			>
				{children}
			</GestureHandlerRootView>
		);
	}

	return <>{children}</>;
};
